<script>
import { FAKE__CATEGORY } from "@src/config/fake-data"; // FIX 刪除
import _debounce from 'lodash/debounce'
export default {
  components: {
    FilterIndutrySelect:() => import("@components/Filter/FilterIndustrySelect"),
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    list: {
      type: Object,
      default: () => {
        return FAKE__CATEGORY
      },
    },

  },
  data() {
    return {
      classList: []
    }
  },
  computed: {
    submitData: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    filterCategory() {
      return this.list?.category.filter((item) => {
        return item.children.length > 0
      })
    },
    currentClass() {
      const result = this.list.category.filter((item) => {
        return item.alias === this.value.category
      })
      return !!result.length && !!result[0].children.length
        ? [
          {
            title: '所屬全部方案',
            alias: '',
          },
          ...result[0].children
        ]
      : []
    },
    currentIndustry() {
      // const industry = this.list.industry.filter((item) => {
      //   return item.alias === this.value.category
      // })
      // const classItem = category[0].children ? category[0].children.filter((classItem)=> {
      //   return classItem.alias === this.value.class
      // }) : []
      return this.list.industry
    }
  },
  methods: {
    onChangeCategory() {
      this.classList = this.currentClass[0]
      this.submitData.class =  this.currentClass[0]?.alias || '';
      this.$emit('input', this.value)
    },
    onChangeClass(item) {
      if(typeof(item) === 'object') {
        if(this.submitData.class === item.alias) return false
        this.submitData.class = item.alias
      }
      this.$emit('input',this.value)
    },
    onClearIndustry() {
      this.submitData.industry = []
      this.$emit('input',this.value)
      // this.$refs.industry.$el.blur()
    },
    onChangeIndustry() {
      this.$emit('input', this.value)
    },
    onChangeKeyWord: _debounce(function () {
      this.$emit('input', this.value)
    }, 800),
  }
}
</script>

<template>
  <div :class="$style.baseFilter">
    <div class="baseFilter__Box">
      <div class="baseFilter__BoxTop">
        <div class="color-primary font-base mb-lg-4 mb-0">依分類</div>
        <div class="d-md-flex d-block">
          <div class="baseFilter__category w-100">
            <el-select 
              v-model="submitData.category" 
              placeholder="請選擇分類"
              class="isStyleBase isCategory w-100"
              clearable
              @change="onChangeCategory"
            >
              <i slot="prefix" class="fal fa-filter"></i>
              <el-option
                v-for="(category, $index) in filterCategory"
                :key="$index" 
                :label="category.title"
                :value="category.alias">
              </el-option>
            </el-select>
          </div>
          <div v-if="submitData.category" class="baseFilter__class ml-md-4 w-100">
            <!-- <el-radio-group v-model="submitData.category" @change="onChangeCategory">
              <el-radio-button
                v-for="(category, $index) in list"
                :key="$index" 
                :label="category.alias"
              >
                {{category.title}}
              </el-radio-button>
            </el-radio-group> -->
            <!-- <div class="row baseFilter__class__list d-lg-flex d-none">
              <div
                v-for="(classItem, $index2) in currentClass"
                :key="$index2" 
                class="col-xl-3 col-lg-4 col-12 baseFilter__class__item"
              >
                <div 
                  class="baseFilter__class__itemInner"
                  :class="{ 'isActive': classItem.alias === submitData.class }"
                  @click="onChangeClass(classItem)"
                >
                  {{ classItem.title }}
                </div>
              </div>
            </div> -->
            <el-select 
              v-model="submitData.class" 
              placeholder="請選擇分類"
              class="isStyleBase isCategory w-100"
              clearable
              @change="onChangeClass"
            >
              <i slot="prefix" class="fal fa-stream"></i>
              <el-option
                v-for="(classItem, $index) in currentClass"
                :key="$index" 
                :label="classItem.title"
                :value="classItem.alias">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="baseFilter__BoxBottom">
        <div class="baseFilter__industry pr-md-4 pr-0">
          <div class="color-primary font-base mb-1 mt-lg-0 mt-3">依產業</div>
            <FilterIndutrySelect
              ref="industry"
              v-model="submitData.industry"
              type="baseFilter"
              :list="currentIndustry" 
              :count="submitData.industry.length"
              class-name="isIndustry"
              class="d-lg-block d-none"
              @clearIndustry="onClearIndustry"
              @change="onChangeIndustry"
            />
            <FilterIndutrySelect
              ref="industry"
              v-model="submitData.industry"
              :list="currentIndustry" 
              :count="submitData.industry.length"
              class-name="isIndustry"
              class="d-lg-none"
              @clearIndustry="onClearIndustry"
              @change="onChangeIndustry"
            />
        </div>
        <div class="baseFilter__keyword">
          <div class="color-primary font-base mb-1 mt-lg-0 mt-3">依關鍵字</div>
          <el-input
            v-model="submitData.query"
            class="isStyleBase isFilter"
            placeholder="輸入關鍵字"
            @input="onChangeKeyWord"
          >
            <i slot="prefix" class="far fa-keyboard"></i>
          </el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.baseFilter {
  background: #fff;
  box-shadow: 0px 2px 4px rgba(33, 69, 88, 0.16);
  border-radius: 2px;
  padding: 3rem 2.5rem;
  @include max-md {
    padding: 2.2rem 1.5rem;
  }
  :global {
    .baseFilter {
      &__class {
        // border: 1px solid $color-line;
        // padding: 1.875rem 2.5rem;
        @include max-lg {
          padding: 0;
          border: 0;
        }
        @include max-md {
          // padding: 0 0 1rem 0;
        }
        &__item {
        
        }
        &__itemInner {
          border: 1px solid $color-line;
          padding: 0.8125rem 0rem;
          text-align: center;
          font-size: 1.25rem;
          margin-bottom: 1.25rem;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          transition: .3s;
          &.isActive {
            background: $color-primary;
            border-color: $color-primary;
            color: #fff;
            &:hover {
              background: $color-primary;
              border-color: $color-primary;
              color: #fff;
            }
          }
          &:hover {
            color: $color-primary;
            border-color: $color-primary;
          }
        }
      }
      &__BoxBottom {
        margin-top: 1.875rem;
        display: flex;
        width: 100%;
        @include max-lg {
          margin-top: 0;
        }
        @include max-md {
          display: block;
        }
      }
      &__industry {
        flex: 1;
      }
      &__keyword {
        flex: 1;
        @include max-md {
          margin-top: 1rem;
        }
      }
    }
  }
}
</style>